import { createContext, useContext } from 'react'

import { AnyRouter, RouteApi } from '@tanstack/react-router'

import { DocumentStatusResponse } from '../types'

type DocumentStatusReportContextValue = {
  data: DocumentStatusResponse
  isFetching: boolean
  routeApi: RouteApi<'/_app/reports/document-status', AnyRouter>
}

export const DocumentStatusReportContext = createContext<DocumentStatusReportContextValue | null>(null)

export const useDocumentStatusReportContext = () => {
  const context = useContext(DocumentStatusReportContext)
  if (!context) {
    throw new Error('useDocumentStatusReportContext must be used within a DocumentStatusReportContext.Provider')
  }
  return context
}
